/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import {
  Select,
  InputLabel,
  MenuItem,
  Checkbox,
  ListItemText,
  Input,
  IconButton,
} from '@material-ui/core';
import { Cached as CachedIcon } from '@material-ui/icons';
import {
  normalizeCategoriesDataFromQuery,
  showCategoryNameWithDepth,
} from 'utils/categories';
import { GET_CATEGORIES_BY_SITE } from '../../queries/category';
import Loading from '../Loading';
import useStyles from './styles';

export const SelectCategories = ({
  categoriesIds,
  siteDomain,
  setCategoriesIds,
}) => {
  const classes = useStyles();

  const [categoriesFromApi, setCategoriesFromApi] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  const [loadCategories, { data, loading }] = useLazyQuery(
    GET_CATEGORIES_BY_SITE,
  );

  const callLoadCategoriesQuery = (isReload) => {
    loadCategories({
      variables: {
        siteDomain,
        reload: isReload,
      },
      fetchPolicy: 'network-only',
    });
  };

  const handleSelectChange = (event, setSelectedCategories) => {
    if (event.target.value) {
      setSelectedCategories(event.target.value);
      setCategoriesIds(event.target.value);
    }
  };

  useEffect(() => {
    if (siteDomain) {
      callLoadCategoriesQuery(false);
    }
  }, [siteDomain]);

  useEffect(() => {
    if (data) {
      const { contentCategoriesBySite } = data;

      if (contentCategoriesBySite && contentCategoriesBySite.length > 0) {
        const normalizedContentCategoriesBySite = normalizeCategoriesDataFromQuery(
          contentCategoriesBySite,
        );
        if (categoriesIds && categoriesIds.length > 0) {
          setSelectedCategories(categoriesIds);
        }

        setCategoriesFromApi(normalizedContentCategoriesBySite);
      } else {
        setCategoriesFromApi([]);
      }
    }
  }, [data]);

  const renderCategoryNamesInSelectLabel = (selectedValues) => {
    if (categoriesFromApi.length > 0) {
      const mappedSelectdNames = selectedValues.map((categoryId) => {
        return (
          categoriesFromApi.find(
            (categoryFrommApi) => categoryFrommApi.id === categoryId,
          )?.name || ''
        );
      });
      return mappedSelectdNames.join(', ');
    }

    return selectedValues.join(', ');
  };

  return (
    <>
      <Loading openLoading={loading} />
      <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
        <InputLabel className={classes.inputLabel} style={{ marginTop: 0 }}>Categories</InputLabel>
        <IconButton onClick={() => callLoadCategoriesQuery(true)} style={{ padding: 0, marginLeft: 4 }}>
          <CachedIcon fontSize="small" />
        </IconButton>
      </div>
      <Select
        fullWidth
        labelId="categories"
        id="categories"
        multiple
        value={selectedCategories}
        onChange={(ev) => handleSelectChange(ev, setSelectedCategories)}
        input={<Input />}
        disabled={!siteDomain}
        renderValue={(selected) => renderCategoryNamesInSelectLabel(selected)}
        MenuProps={classes.MenuProps}
      >
        {categoriesFromApi.map((category) => (
          <MenuItem key={category.id} value={category.id}>
            <Checkbox checked={selectedCategories.indexOf(category.id) > -1} />
            <ListItemText primary={showCategoryNameWithDepth(category)} />
          </MenuItem>
        ))}
      </Select>
    </>
  );
};
